/**
 * Copyright (c) Microsoft. All rights reserved.
 */

export class AzureSubscriptionStore {
    public id: string;

    public path: string;

    public name: string;

    constructor(id: string, data: Partial<Omit<AzureSubscriptionStore, 'id'>>) {
        this.id = id;
        this.path = data.path;
        this.name = data.name;
    }
}
